<div class="number-selector">
  <div class="number-selector__header">
    <h2 class="number-selector__label">{{ label }}</h2>
    <ng-container *ngIf="showAdvice">
      <img class="number-selector__info" mfpLazyImage lazySrc="assets/icons/info-alert.svg" alt="" />
      <div class="number-selector__popup mfp-white-box">
        <ng-content></ng-content>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="!loading">
    <div class="number-selector__controlers">
      <img
        class="controlers__button"
        mfpLazyImage
        lazySrc="assets/icons/subtract-circle.svg"
        alt=""
        [ngClass]="{
          'controlers__button--disabled': innerValue - 1 < min || disabled,
          'controlers__button--readonly': readonly
        }"
        [draggable]="false"
        (mousedown)="subtract()"
        (mouseLongPress)="subtract($event)"
        mfpLongPress
      />
      <input
        class="controlers__input"
        autocomplete="off"
        type="number"
        [id]="name"
        [name]="name"
        [(ngModel)]="value"
        [disabled]="disabled || readonly"
        (ngModelChange)="changeCoverageInput()"
      />
      <ng-container *ngIf="value">
        <p
          class="input__currency"
          [style.left.px]="currencyPosition === 'right' ? 125 + 6 * (value.toString().length - 1) : 85 - 6 * (value.toString().length - 1)"
          [ngClass]="{ 'input__currency--hide': value.toString().length - 1 > 6 }"
        >
          {{ currency }}
        </p>
      </ng-container>
      <img
        class="controlers__button"
        mfpLazyImage
        lazySrc="assets/icons/add-circle.svg"
        alt=""
        [ngClass]="{
          'controlers__button--disabled': innerValue + 1 > max || disabled,
          'controlers__button--readonly': readonly
        }"
        [draggable]="false"
        (mousedown)="add()"
        (mouseLongPress)="add($event)"
        mfpLongPress
      />
    </div>
  </ng-container>
  <ng-container *ngIf="loading">
    <div class="number-selector__skeleton-box"></div>
  </ng-container>
</div>
